import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';

import * as UtilitiesGuards from 'src/app/guards/guards';

import { PageCredentialComponent } from '../login/page-credential/page-credential.component';
import { MainComponent } from './main.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [
            () => UtilitiesGuards.isLogged(),
            (route: ActivatedRouteSnapshot) => UtilitiesGuards.checkPermissions(route)
        ],
        canActivateChild: [
            () => UtilitiesGuards.isLogged(),
            (route: ActivatedRouteSnapshot) => UtilitiesGuards.checkPermissions(route)
        ],
        component: MainComponent,
        children: [
            {
                path: 'update-credential', component: PageCredentialComponent
            },
            {
                path: 'workout', loadChildren: () => import('src/app/views/main/views/workout/workout.module').then(m => m.WorkoutModule)
            },
            {
                path: 'schedule', loadChildren: () => import('src/app/views/main/views/schedule/schedule.module').then(m => m.ScheduleModule)
            },
            {
                path: 'activities', loadChildren: () => import('src/app/views/main/views/activities/activities.module').then(m => m.ActivitiesModule)
            },
            {
                path: 'kpi', loadChildren: () => import('src/app/views/main/views/kpi/kpi.module').then(m => m.KpiModule)
            },
            {
                path: 'members', loadChildren: () => import('src/app/views/main/views/members/members.module').then(m => m.MembersModule)
            },
            {
                path: 'capacity', loadChildren: () => import('src/app/views/main/views/capacity/capacity.module').then(m => m.CapacityModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})
export class MainRoutingModule { }
